<template>

  <div class='card'>
    <div class='card-image'></div>
    <div class='card-content'>
      <h3 class='card-title'> {{ title }} </h3>
      <p> {{ truncatedText }} </p>

    </div>
    <div class='card-action' v-if="purchaseLink">
      <a class='btn' :href="purchaseLink"> Get It </a>
      <div class='cost'> $ {{ cost }} </div> asdfasdfadfasdfasdf
    </div> 
    
    <!-- <div class='card-action'>
      <a :href="url"> Request </a>
    </div> -->
  
  </div>


</template>

<script>
// @ is an alias to /src

export default {
  name: 'Product',
  props: ['title', 'cost', 'description', 'category', 'infoLink', 'purchaseLink', 'status', 'needsFlex'],
  computed: {
    truncatedText: function () {
      if(typeof this.description == 'string') {
        if(this.description.length > 250){
          return this.description.substr(0, 250).trim() + '...'
        }
        else {
          return this.description
        }
        
      }
      else {
        return ''
      }
    },
    flexTop: function () {
      if(this.needsFlex) {
        return '<div class="flex-card">'
      }
      else {
        return ''
      }
    },
    flexBottom: function () {
      if(this.needsFlex) {
        return '</div>'
      }
      else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
  .cost {
    padding-top: 7px;
    float: right;
    color: green;
  }
</style>
